"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (state = { host: '', search: '', pathname: '' }) => {
    return state;
};
